import React, { Component } from 'react';
import * as firebase from 'firebase';
import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Navigation from './components/navigation';
import Home from './views/home/index';
import Libros from './views/libros';
import InfoLibro from './views/libros/infoLibro';
import Revistas from './views/revistas';
import Consultoria from './views/consultoria';
import Cursos from './views/cursos';
import Contacto from './views/contacto';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Universidad from './views/universidad';
import Compra from './views/compra';
import Nosotros from './views/nosotros/index';
// import ListaRevistas from "./views/listaRevistas/index";
import RenderPDF from './views/revistas/renderPDF';
import ShowCursos from './views/cursos/showCursos';
import NumeroDetalle from './views/revistas/numberDetail';
import NotFound from './components/notFound';

var config = {
  apiKey: 'AIzaSyCdQpO9rzhfgjIUTEuQMVFLu9p_fBZR9FE',
  authDomain: 'tyreditorial.firebaseapp.com',
  databaseURL: 'https://tyreditorial.firebaseio.com',
  projectId: 'tyreditorial',
  storageBucket: 'tyreditorial.appspot.com',
  messagingSenderId: '588105115411',
};
firebase.initializeApp(config);
firebase.auth().signInAnonymously().catch(console.error);

class App extends Component {
  componentWillMount() {}
  render() {
    return (
      <MuiThemeProvider>
        <div className="root" style={{ height: '100%' }}>
          <Router>
            <div style={{ height: '100%' }}>
              <Navigation />
              <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/nosotros" component={Nosotros} />
                <Route exact path="/libros" component={Libros} />
                <Route exact path="/libros/:nombre" component={InfoLibro} />
                {/* <Route exact path="/revistas" component={ListaRevistas} /> */}
                <Route exact path="/revistas/:type" component={Revistas} />
                <Route exact path="/revistas/:type/:numero" component={NumeroDetalle} />
                <Route exact path="/revistas/:type/:numero/:contenido" component={RenderPDF} />
                <Route path="/consultoria/:position" component={Consultoria} />
                <Route exact path="/cursos" component={Cursos} />
                <Route exact path="/cursos/:nombre" component={ShowCursos} />
                <Route path="/contacto" component={Contacto} />
                <Route path="/universidad" component={Universidad} />
                <Route path="/compra/:id" component={Compra} />
                <Route component={NotFound} />
              </Switch>
            </div>
          </Router>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js